import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './styles/global.css';
import './styles/chat.css';
import App from './components/App';


ReactDOM.render(
    <React.StrictMode>
        {<App/>}
    </React.StrictMode>,
    document.getElementById('root')
);

